import { MapPin } from 'lucide-react';
import PartnerActionsMenu from '../PartnerActionsMenu/PartnerActionsMenu';

const PartnerMobileCard = ({ partner, onView, onEdit, onFreeze, onDelete }) => {
  return (
    <div className="p-4 space-y-3 bg-white hover:bg-slate-50/50 transition-colors">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 rounded-full bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center overflow-hidden font-bold text-xs flex-shrink-0 shadow-sm">
            {partner.logo_url ? (
              <img src={partner.logo_url} alt="Logo" className="w-full h-full object-cover" />
            ) : (
              (partner.business_name || '?').charAt(0).toUpperCase()
            )}
          </div>
          <div className="min-w-0">
            <h4
              className="text-xs font-semibold text-slate-800 truncate cursor-pointer"
              title={partner.business_name}
              onClick={() => onView && onView(partner)}
            >
              {partner.business_name}
            </h4>
            {partner.city && (
              <div className="text-[11px] text-slate-400 font-medium truncate flex items-center gap-1 mt-0.5">
                <MapPin size={11} className="text-slate-400 flex-shrink-0" />
                <span>{partner.city}</span>
              </div>
            )}
          </div>
        </div>

        <PartnerActionsMenu
          partner={partner}
          onView={onView}
          onEdit={onEdit}
          onFreeze={onFreeze}
          onDelete={onDelete}
        />
      </div>

      <div className="flex items-center justify-between text-xs pt-2 border-t border-slate-50">
        <div>
          <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-medium capitalize bg-teal-50 text-[#067978] border border-teal-100/70">
            {partner.category
              ? partner.category.charAt(0).toUpperCase() + partner.category.slice(1).toLowerCase()
              : 'Shop'}
          </span>
        </div>

        <div className="text-slate-500 font-mono text-[11px]">{partner.phone_number || 'N/A'}</div>

        {partner.isActive !== false ? (
          <span className="inline-flex items-center text-xs font-bold text-emerald-600">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-1.5"></span>
            Active
          </span>
        ) : (
          <span className="inline-flex items-center text-xs font-bold text-rose-500">
            <span className="w-1.5 h-1.5 rounded-full bg-rose-500 mr-1.5"></span>
            Frozen
          </span>
        )}
      </div>
    </div>
  );
};

export default PartnerMobileCard;
